module.exports = __webpack_public_path__ + "img/02.ba7434e1.jpg";